import { css } from '@emotion/css'
import appSettings from '../../app/app-settings'

const cateringCss = {
  section: () => css({
    textAlign: "center",
    fontFamily: "SourceSerifProRegular",
    fontSize: 16,

    "ul": {
      listStyleType: "none",
      padding: 0,
      margin: 0,
      lineHeight: 1.5,
    },

    [appSettings.mediaQueries.smallTablet]: {
      fontSize: 15,
    },
  }),

  wrapperSeatingPlanFoto: (isRotated: boolean) => css({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: isRotated ? 700 : 500,
    maxWidth: "100%",
    maxHeight: "100%",

    [appSettings.mediaQueries.smallTablet]: {
      height: isRotated ? 350 : 250,
    },
  }),

  seatingPlanFoto: (isRotated: boolean) => css({
    transform: isRotated ? "rotate(-90deg)" : undefined,
    transformOrigin: "center",
    objectFit: "contain",
    width: isRotated ? 700 : "100%",
    height: "100%",
    maxWidth: "100%",

    [appSettings.mediaQueries.smallTablet]: {
      width: isRotated ? 350 : "100%",
    },
  }),

  sectionTitle: () => css({
    color: appSettings.colors.blueColor,
    fontFamily: "SourceSerifProBold",
    fontSize: 20,

    [appSettings.mediaQueries.smallTablet]: {
      fontSize: 18,
    },
  }),

  sectionSubtitle: () => css({
    color: appSettings.colors.blueColor,
    fontFamily: "SourceSerifProRegular",
    fontSize: 16,
    marginBottom: 14,
  }),

  lunchSubtitle: () => css({
    color: appSettings.colors.blueColor,
    fontFamily: "SourceSerifProBold",
    fontSize: 18,
    marginTop: 20,

    [appSettings.mediaQueries.smallTablet]: {
      fontSize: 16,
    },
  }),

  paragraphSubtitle: () => css({
    fontFamily: "SourceSerifProRegular",
    fontSize: 16,
    fontWeight: 200,
  }),

  button: () => css({
    fontSize: 16,
    backgroundColor: appSettings.colors.blueBackground,
    border: `1px solid ${appSettings.colors.blueColor}`,
    color: appSettings.colors.blueColor,
    borderRadius: 8,
    padding: 8,
    outline: "none",
    marginTop: 20,

    "&:active": {
      filter: "brightness(0.95)",
    },
  }),
}

export default cateringCss
